import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'
import { EMAIL_PROFILE_RAW_MESSAGE_WHOM_LABELS } from '../EmailProfileRawMessage.constants'

import * as styles from './Participants.module.css'

function Participants({ bcc, cc, sender, to }) {
  const { t } = useTranslation()

  return (
    <div className={styles.participants}>
      <div className={styles.owner}>
        <Text unread className={styles.text}>
          {sender.name}
        </Text>
        <Text className={styles.text}>{`<${sender.email}>`}</Text>
      </div>

      {[to, cc, bcc].map((items, index) =>
        items.length > 0 ? (
          <Text className={styles.text} key={index}>
            {t(EMAIL_PROFILE_RAW_MESSAGE_WHOM_LABELS[index])}:{' '}
            {items.map(item => `${item.fullname} <${item.email}>`).join(', ')}
          </Text>
        ) : null
      )}
    </div>
  )
}

export default Participants
